import { FC, HTMLProps } from 'react';
import cn from 'classnames';
import css from './Slider.module.scss';

export interface SliderProps extends HTMLProps<HTMLInputElement> {}

export const Slider: FC<SliderProps> = ({ className, ...props }) => (
  <input type="range" className={cn(css.slider, className, props.disabled && css.disabled)} {...props} />
);
